import React from "react";
import { useTranslation } from "react-i18next";
import { GridContainer, LabeledDataItem, GridItem, DividerSpg } from "@duosoftbg/nacid-components";
import { ProcessEnvironments } from "@duosoftbg/nacid-frontoffice-components";
import { ApiEndpoints } from "../../../axios/api/endpoints";

const SeRecognitionContent = ({ data }) => {
  const { t } = useTranslation();

  const buildDownloadDecisionUrl = (rootDirectory, relativePath, fileId) => {
    return `${ProcessEnvironments.Api.FrontOffice.Core}/api/v1${ApiEndpoints.file.get}?rootDirectory=${rootDirectory}&relativePath=${relativePath}&fileId=${fileId}`;
  };

  return (
    <GridContainer spacing={2}>
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.applicationDate" data={data.applicationDate} />
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.applicationNumber" data={data.applicationNumber} />
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.applicationStatus" data={data?.applicationStatus?.name} />
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.applicantName" data={data.applicantName} />
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.decisionNumber" data={data.decisionNumber} />
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.accessCode" data={data.accessCode} />
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.bgProfession" data={data.bgProfession} />
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.schoolName" data={data.schoolName} />
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.schoolSettlement" data={data.schoolSettlement} />
      <LabeledDataItem sm={12} md={4} labelCode="l.detail.schoolCountry" data={data.schoolCountry?.name} />
      {data.attachments?.length > 0 && (
        <>
          <GridItem sm={12} md={12}>
            <DividerSpg variant={"fullWidth"} />
          </GridItem>
          <GridItem sm={12} md={12}>
            <strong style={{ fontSize: "13px" }}>{t("l.decisions")}:</strong>
            <ul>
              {data.attachments.map((attachment, index) => (
                <li key={index} style={{ marginTop: "7px" }}>
                  <a
                    href={buildDownloadDecisionUrl(
                      attachment.rootDirectory,
                      attachment.relativePath,
                      attachment.fileId,
                    )}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {attachment.fileName || `${t("l.download.file")} ${index + 1}`}
                  </a>
                </li>
              ))}
            </ul>
          </GridItem>
        </>
      )}
    </GridContainer>
  );
};

export default SeRecognitionContent;
